import * as React from 'react';

import { cn } from '../lib/utils';

function Label({ className, ...props }: React.ComponentProps<'label'>) {
  return (
    <label
      data-slot="label"
      className={cn('mb-1 block text-[0.8rem] font-semibold text-brand-navy', className)}
      {...props}
    />
  );
}

export { Label };
